//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getProductDetail(key){
    return _axios({
        url: `/api/storeAllocate/getAbsoluteDetail?id=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/storeAllocate/absoluteSubmit`,
        method: 'post',
        data:data
    })
}
